export {default as FooterIndividuel} from './FooterIndividuel';
export {default as FooterCollective} from './FooterCollective';